(async() => {

  if (!customElements.get('quick-shop')) {

    class QuickShop extends HTMLElement {

      constructor() {

        super();

        this.parentCard = this.closest('[data-product-card]');
        this.popup = this.querySelector('[data-quick-shop-popup]');
        this.popupIsOpenClass = 'quick-shop__popup--is-open';
        this.selectedPrice = this.querySelector('[data-quick-shop-selected-price]')
        this.selectedCompareAtPrice = this.querySelector('[data-quick-shop-selected-compare-at-price]')

        // Close
        this.clickOutside = function (event) {
          event.stopPropagation();
          const searchParentCard = event.target.closest('[data-product-card]')
          if(searchParentCard == null && this.parentCard != searchParentCard) {
            this.popup.classList.remove(this.popupIsOpenClass);
            window.removeEventListener('click', this.handleClickOutside);
          }
        }

        this.handleClickOutside = this.clickOutside.bind(this);

        // Toggle popup
        this.parentCard.querySelectorAll('[data-quick-shop-toggle]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.stopPropagation();
            this.closeOthers(event);
            this.onPopupToggle();
          });
        });


        // Bind option select events
        this.querySelectorAll('[data-quick-shop-option]').forEach((option) => {
          option.addEventListener('click', () => {
            this.onOptionSelect(option.value, option.dataset.variantInventoryQuantity, option.dataset.variantPrice, option.dataset.variantCompareAtPrice);
          });
        });

      }

      /**
       * closeOthers
       * @description Closes all other quick shop popups.
       */
      closeOthers() {
        document.querySelectorAll('[data-quick-shop-popup]').forEach((popup) => {
          if(popup != this.popup) {
            popup.classList.remove(this.popupIsOpenClass);
          }
        });
      }

      /**
       * Toggles the options popup
       * @description Renders the products based on the fetch url data.
       */
      onPopupToggle() {
        this.popup.classList.toggle(this.popupIsOpenClass);
        if(this.popup.classList.contains(this.popupIsOpenClass) && window.innerWidth < 768) {
          window.addEventListener('click', this.handleClickOutside);
        }
      }

      /**
       * Adds a variant to the cart
       * @description Adds the clicked option/variant to the cart leveraging the product form component.
       * @param {String} variantId
       * @param {String} inventoryQuantity
       * @param {String} variantPrice
       * @param {String} variantCompareAtPrice
       */
      onOptionSelect(variantId, inventoryQuantity, variantPrice, variantCompareAtPrice) {

        // Update product form component with the selected variant
        const productForm = this.querySelector('product-form');
        const productType = productForm.querySelector( 'input[name="product_type"]').value;
        const hiddenId = productForm.querySelector('input[name="id"]');
        const hiddenInventoryQty = productForm.querySelector('input[name="inventory_quantity"]');
        const submitButton = productForm.querySelector('[type="submit"]');

        hiddenId.value = variantId;
        hiddenInventoryQty.value = inventoryQuantity;

        // Update the selected price in popup unless it's a giftcard product
        if (productType != 'giftcard') {
          this.selectedPrice.innerText = variantPrice;
          this.selectedCompareAtPrice.innerText = variantCompareAtPrice;
        }

        // Update the submit button
        if(this.isOptionSelected()) {
          submitButton.classList.add('button--primary');
          submitButton.classList.remove('button--outline');
          submitButton.querySelector('[data-product-form-submit-text]').innerText = productStrings.add_to_cart;
        } else {
          submitButton.classList.add('button--outline');
          submitButton.classList.remove('button--primary');
          submitButton.querySelector('[data-product-form-submit-text]').innerText = productStrings.select_size;
        }

      }

      /**
       * isOptionSelected
       * @description Checks if at least one option is selected.
       * @retuns {Boolean}
       */
      isOptionSelected() {
        return this.querySelector('[data-quick-shop-option]:checked') ? true : false;
      }

    }

    window.QuickShop = QuickShop;

    customElements.define('quick-shop', QuickShop);

  }

})();